import { render, staticRenderFns } from "./ResponsibilityAssignmentsTab.vue?vue&type=template&id=9eb77be0&scoped=true"
import script from "./ResponsibilityAssignmentsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityAssignmentsTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityAssignmentsTab.vue?vue&type=style&index=0&id=9eb77be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb77be0",
  null
  
)

export default component.exports